export default __webpack_public_path__ + "static/media/UNIe.6982cfe0.png";